<template>
	<!-- Layout inner -->
  <div class="layout-inner">
    <!-- Layout navbar -->
    <navbar></navbar>
    <!-- / Layout navbar -->
    <div class="layout-container">
      <div class="layout-content">

        <div class="hd_bar">
          <div class="hd_ic ic-course"></div>
          <div class="hd_txt">
            <v-clamp class="title_txt" autoresize :max-lines="2" id="courseTitle">{{ course.title }}</v-clamp>

            <b-popover ref="courseTitlePopupContainer" target="courseTitle" triggers="click" placement="top" class="title_popup" container="courseTitleContainer">
              <div class="title_container">
                {{ course.title }}
              </div>
              <div class="ic_container">
                <span class="ic ic-close" v-on:click="hideCourseTitlePopup"></span>
              </div>
            </b-popover>
            <div id="courseTitleContainer" class="title_container_popup"></div>

          </div>
        </div>

        <div class="row sub_hd_bar resource">
          <div class="col-12">
            <div class="sub_hd_ic">
              <span v-if="entity.fileType === 'assessment'" class="ic ic-assessment"></span>
              <span v-if="entity.fileType === 'video'" class="ic ic-video"></span>
              <span v-if="entity.fileType === 'pdf'" class="ic ic-file-pdf"></span>
              <span v-if="entity.fileType === 'doc' || entity.fileType === 'docx'" class="ic ic-file-word"></span>
              <span v-if="entity.fileType === 'xlsx'" class="ic ic-file-excel"></span>
              <span v-if="entity.fileType === 'html'" class="ic ic-pageURL"></span>
              <span v-if="entity.fileType === 'externalurl'" class="ic ic-pageURL"></span>
              <span v-if="entity.fileType === 'other'" class="ic ic-pageURL"></span>
              <span v-if="entity.fileType === 'jpg' || entity.fileType === 'jpeg' || entity.fileType === 'png' || entity.fileType === 'gif'" class="ic ic-image"></span>
            </div>
            <div class="sub_hd_txt_lg">
              <v-clamp class="title_txt" autoresize :max-lines="2" id="entityTitle">{{ entity.title }}</v-clamp>

              <b-popover ref="entityTitlePopupContainer" target="entityTitle" triggers="click" placement="top" class="title_popup" container="entityTitleContainer">
                <div class="title_container">
                  {{ entity.title }}
                </div>
                <div class="ic_container">
                  <span class="ic ic-close" v-on:click="hideEntityTitlePopup"></span>
                </div>
              </b-popover>
              <div id="entityTitleContainer" class="title_container_popup"></div>

            </div>
          </div>
        </div>
        <!-- Page content -->
        <div class="container-fluid flex-grow-1 container-p-y">

          <div class="pg_container_rate_resourse">

            <div class="row">
        			<div class="col-sm-12 col-xl-12">

                <div class="head">Did this resource improve your understanding of the content?</div>

                <div class="row ratings-row ratings-row_5">
                  <div class="col-8 label_container">
                    <input class="mr-2" type="radio" name="ranking" id="five" value="5" v-model="rating" @change="enableStarAndOkButton">
                    <label class="m-0" for="five">Extremely Helpful</label>
                  </div>
                  <div class="col-4 star_container">
                    <label for="five" class="ic-star-full"></label>
                    <label for="five" class="ic-star-full"></label>
                    <label for="five" class="ic-star-full"></label>
                    <label for="five" class="ic-star-full"></label>
                    <label for="five" class="ic-star-full"></label>
                  </div>
                </div>

                <div class="row ratings-row ratings-row_4">
                  <div class="col-8 label_container">
                    <input class="mr-2" type="radio" name="ranking" id="four" value="4" v-model="rating" @change="enableStarAndOkButton">
                    <label class="m-0" for="four">Very Helpful</label>
                  </div>
                  <div class="col-4 star_container">
                    <label for="four" class="ic-star-full"></label>
                    <label for="four" class="ic-star-full"></label>
                    <label for="four" class="ic-star-full"></label>
                    <label for="four" class="ic-star-full"></label>
                  </div>
                </div>

                <div class="row ratings-row ratings-row_3">
                  <div class="col-8 label_container">
                    <input class="mr-2" type="radio" name="ranking" id="three" value="3" v-model="rating" @change="enableStarAndOkButton">
                    <label class="m-0" for="three">Moderately Helpful</label>
                  </div>
                  <div class="col-4 star_container">
                    <label for="three" class="ic-star-full"></label>
                    <label for="three" class="ic-star-full"></label>
                    <label for="three" class="ic-star-full"></label>
                  </div>
                </div>

                <div class="row ratings-row ratings-row_2">
                  <div class="col-8 label_container">
                    <input class="mr-2" type="radio" name="ranking" id="two" value="2" v-model="rating" @change="enableStarAndOkButton">
                    <label class="m-0" for="two">Slightly Helpful</label>
                  </div>
                  <div class="col-4 star_container">
                    <label for="two" class="ic-star-full"></label>
                    <label for="two" class="ic-star-full"></label>
                  </div>
                </div>

                <div class="row ratings-row ratings-row_1">
                  <div class="col-8 label_container">
                     <input type="radio" class="mr-2" name="ranking" value="1" id="one" v-model="rating" @change="enableStarAndOkButton">
                     <label class="m-0" for="one">Not Helpful</label>
                  </div>
                  <div class="col-4 star_container">
                    <label for="one" class="ic-star-full"></label>
                  </div>
                </div>

                <div class="row ratings-row">
                  <div class="col-8 label_container">
                    <input type="radio" class="mr-2" name="ranking" value="0" id="zero" v-model="rating" @change="enableStarAndOkButton">
                    <label class="m-0" for="zero">N/A (Not Accessible)</label>
                  </div>
                  <div class="col-4 star_container">
                  </div>
                </div>

                <div class="row feedback_sec">
                  <div>If you have any comments please type it in (optional)</div>
                  <textarea rows="3" cols="48" id="feedback" maxlength="256" v-model.trim="feedback"></textarea>
                </div>

                <div class="float-right mt-2">
                  <b-button v-on:click="leaving" class="btn button-primary next float-right" disabled id="ok-btn" aria-label="ok"> ok </b-button>
                </div>

        			</div>
        		</div>

          </div>

        </div>
      </div>
    </div>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Navbar from '../../misc/components/./Navbar'
import VClamp from 'vue-clamp'

export default {
  name: 'resource-rate',
  props: ['uuid', 'entityUuid', 'entityType', 'isTransitionPage'],
  components: {
    Navbar,
    VClamp
  },
  data: () => {
    return {
      rating: -1,
      feedback: null
    }
  },

  mounted () {
    this.loadDetail()
  },

  methods: {
    ...mapActions([
      'stopActivity',
      'storeRating',
      'loadNextEntityDetail',
      'loadCourseDetail',
      'loadEntityDetail'
    ]),

    async loadDetail () {
      await this.loadCourseDetail(this.uuid)
      let entityDetailInfo = {
        'entityType': this.entityType,
        'entityUuid': this.entityUuid
      }
      await this.loadEntityDetail(entityDetailInfo)
    },

    enableStarAndOkButton () {
      if ($('#four').is(':checked')) {
        $('.ratings-row_4').addClass('selected-star')
        $('.ratings-row_0, .ratings-row_5, .ratings-row_3, .ratings-row_2, .ratings-row_1 ').removeClass('selected-star')
      } else if ($('#three').is(':checked')) {
        $('.ratings-row_3').addClass('selected-star')
        $('.ratings-row_0, .ratings-row_5, .ratings-row_4, .ratings-row_2, .ratings-row_1 ').removeClass('selected-star')
      } else if ($('#two').is(':checked')) {
        $('.ratings-row_2').addClass('selected-star')
        $('.ratings-row_0, .ratings-row_5, .ratings-row_4, .ratings-row_3, .ratings-row_1 ').removeClass('selected-star')
      } else if ($('#one').is(':checked')) {
        $('.ratings-row_1').addClass('selected-star')
        $('.ratings-row_0, .ratings-row_5, .ratings-row_4, .ratings-row_3, .ratings-row_2 ').removeClass('selected-star')
      } else if ($('#five').is(':checked')) {
        $('.ratings-row_5').addClass('selected-star')
        $('.ratings-row_0, .ratings-row_3, .ratings-row_4, .ratings-row_2, .ratings-row_1 ').removeClass('selected-star')
      } else if ($('#zero').is(':checked')) {
        $('.ratings-row_0').addClass('selected-star')
        $('.ratings-row_3,.ratings-row_5, .ratings-row_4, .ratings-row_2, .ratings-row_1 ').removeClass('selected-star')
      }
      $('#ok-btn').prop('disabled', false)
      $('#ok-btn').removeClass('disabled')
    },

    sendRating () {
      let feedback = $.trim(this.feedback)
      let ratingInfo = {
        'courseId': this.uuid,
        'learningContentId': this.entityUuid,
        'userId': this.userObj.uuid,
        'institutionId': null,
        'rating': this.rating,
        'ratingLabel': null,
        'feedback': ((feedback.length > 0) ? feedback : null)
      }
      this.storeRating(ratingInfo)
    },

    leaving () {
      let stopActivity = {
        'userId': this.userObj.uuid,
        'entityUuid': this.entityUuid,
        'rating': this.rating
      }
      this.stopActivity(stopActivity).then((res) => {
        this.sendRating()
        if (this.entityCompetency && this.entityCompetency.status === 2) {
          let nextEntityDetailInfo = {
            'courseUuid': this.uuid,
            'entityType': this.entityType,
            'entityUuid': this.entityUuid
          }
          this.loadNextEntityDetail(nextEntityDetailInfo)
          if (this.isTransitionPage) {
            return this.$router.push({ name: 'entityResult', params: { uuid: this.uuid, entityType: this.entityType, entityUuid: this.entityUuid } })
          }
          return this.$router.push({ name: 'entityDetail', params: { uuid: this.uuid, entityType: this.entityType, entityUuid: this.entityUuid } })
        } else {
          return this.$router.push({ name: 'entityResult', params: { uuid: this.uuid, entityType: this.entityType, entityUuid: this.entityUuid } })
        }
      })
    },
    hideCourseTitlePopup () {
      this.$refs.courseTitlePopupContainer.$emit('close')
    },
    hideEntityTitlePopup () {
      this.$refs.entityTitlePopupContainer.$emit('close')
    }
  },

  computed: {
    ...mapState({
      'userObj': state => state.login.userObj,
      'course': state => state.dashboard.course,
      'entity': state => state.dashboard.entity,
      'entityCompetency': state => state.dashboard.entityCompetency
    })
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/app/assessment/components/ResourceRate.vue